<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 style="margin-top: 20px" v-if="$vuetify.breakpoint.xs">
        <p :class="$vuetify.breakpoint.smAndDown ? 'h2' : 'h1'">Blog</p>
      </v-flex>

      <v-flex xs12 align-center>
        <v-img class="img-responsive" src="blog/por-do-sol.jpg" :height="$vuetify.breakpoint.xs ? 150 : $vuetify.breakpoint.sm ? 200 : 600"> </v-img>
      </v-flex>

      <v-flex v-if="$vuetify.breakpoint.smAndDown" xs12 class="text-center" style="margin-top: 40px; margin-bottom: 40px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.blog"></p>
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.mdAndUp" offset-md3 md6 class="text-center" style="margin-top: 40px; margin-bottom: 40px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.blog"></p>
      </v-flex>

      <v-flex xs12 align-center>
        <v-img class="img-responsive" src="blog/bambus.jpg" :height="$vuetify.breakpoint.xs ? 150 : $vuetify.breakpoint.sm ? 200 : 600"> </v-img>
      </v-flex>

      <v-flex xs12 align-center>
        <v-divider style="margin: 20px"></v-divider>
      </v-flex>

      <v-flex xs12 v-if="carregando" class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-flex>

      <v-flex xs12 v-else-if="categorias.length === 0" class="text-center">
        <p class="p16">Nenhum conteúdo disponível no momento.</p>
      </v-flex>

      <v-flex xs12 v-else>
        <v-expansion-panels v-model="painel" popout focusable>
          <v-expansion-panel v-for="(categoria, index) in categorias" :key="categoria.nome">
            <v-expansion-panel-header color="#99b8bf" :id="categoria.slug">{{ categoria.nome }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout wrap>
                <v-flex xs12 v-for="post in categoria.posts" :key="post.id" class="mb-6" :id="`post-${post.slug}`">
                  <v-card outlined class="blog-post-card" @click="aplicarSeoPost(post)">
                    <v-card-text>
                      <v-layout wrap class="blog-post-layout">
                        <v-flex xs12 :md6="!!post.imagemCapa" :md12="!post.imagemCapa" class="blog-post-conteudo">
                          <p :class="$vuetify.breakpoint.smAndDown ? 'h3' : 'h2'">{{ post.titulo }}</p>
                          <p class="p12" v-if="post.dtPublicacao">{{ formatarData(post.dtPublicacao) }}</p>
                          <div class="blog-conteudo" :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="prepararConteudo(post.conteudo)"></div>
                        </v-flex>
                        <v-flex xs12 md6 v-if="post.imagemCapa" class="blog-post-capa">
                          <v-img class="img-responsive" :src="resolveImagem(post.imagemCapa)" :height="$vuetify.breakpoint.sm ? 800 : 600" contain></v-img>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>

      <v-flex xs12 :style="`height: ${$vuetify.breakpoint.xs ? '160px' : '120px'};`"></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { api } from "@/services/api.js";

export default {
  data() {
    return {
      painel: [],
      carregando: false,
      categorias: [],
      tituloPadraoPagina: "Blog | Espaço Mossoo"
    };
  },
  methods: {
    obterOuCriarMetaTag(nome) {
      let tag = document.querySelector(`meta[name="${nome}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", nome);
        document.head.appendChild(tag);
      }
      return tag;
    },
    removerHtml(texto) {
      return String(texto || "")
        .replace(/<[^>]+>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    },
    limitarTexto(texto, limite) {
      const valor = String(texto || "").trim();
      if (!valor) return "";
      if (valor.length <= limite) return valor;
      return `${valor.slice(0, limite - 1).trim()}…`;
    },
    aplicarSeoPost(post) {
      if (!post) return;

      const titulo = this.limitarTexto(post.metaTitle || post.titulo || this.tituloPadraoPagina, 200);
      const descricaoBase = post.metaDescription || this.removerHtml(post.conteudo);
      const descricao = this.limitarTexto(descricaoBase, 320);

      document.title = titulo || this.tituloPadraoPagina;
      const tagDescricao = this.obterOuCriarMetaTag("description");
      tagDescricao.setAttribute("content", descricao || "Blog do Espaço Mossoo");
    },
    aplicarSeoPadrao() {
      document.title = this.tituloPadraoPagina;
      const tagDescricao = this.obterOuCriarMetaTag("description");
      tagDescricao.setAttribute("content", "Conteúdos do blog do Espaço Mossoo sobre natureza, hospedagem e sustentabilidade.");
    },
    obterSlugPostAlvo() {
      const slugQuery = String(this.$route.query.post || "").trim();
      if (slugQuery) return slugQuery;

      const slugHash = String((this.$route.hash || "").replace(/^#/, "")).trim();
      return slugHash;
    },
    obterIndexCategoriaPorPostSlug(slugPost) {
      return this.categorias.findIndex((categoria) => (categoria.posts || []).some((post) => post.slug === slugPost));
    },
    rolarAtePost(slugPost, tentativa = 0) {
      const alvo = document.getElementById(`post-${slugPost}`);
      if (alvo) {
        alvo.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }

      if (tentativa >= 8) return;
      setTimeout(() => this.rolarAtePost(slugPost, tentativa + 1), 140);
    },
    selecionarPostPorLink() {
      const slugPost = this.obterSlugPostAlvo();
      if (!slugPost) {
        this.aplicarSeoPadrao();
        return;
      }

      const listaPosts = this.categorias.flatMap((grupo) => grupo.posts || []);
      const post = listaPosts.find((item) => item.slug === slugPost);
      if (!post) {
        this.aplicarSeoPadrao();
        return;
      }

      const indexCategoria = this.obterIndexCategoriaPorPostSlug(slugPost);
      if (indexCategoria >= 0) {
        this.painel = indexCategoria;
      }

      this.aplicarSeoPost(post);
      this.$nextTick(() => {
        setTimeout(() => this.rolarAtePost(slugPost), 220);
      });
    },
    obterBaseApi() {
      return String(process.env.VUE_APP_URL_API || "")
        .replace(/\/api\/(public|privado|adm)\/?$/, "")
        .replace(/\/api\/?$/, "")
        .replace(/\/$/, "");
    },
    normalizarUrlDuplicada(url) {
      return String(url || "")
        .replace(/\/api\/public\/\/api\/public\//gi, "/api/public/")
        .replace(/\/api\/\/api\//gi, "/api/");
    },
    normalizar(texto) {
      return String(texto || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .toLowerCase();
    },
    agruparPorCategoria(posts) {
      const grupos = {};
      posts.forEach((post) => {
        const nomeCategoria = post.categoria || "Sem Categoria";
        if (!grupos[nomeCategoria]) {
          grupos[nomeCategoria] = [];
        }
        grupos[nomeCategoria].push(post);
      });

      return Object.keys(grupos).map((nome) => ({
        nome,
        slug: this.normalizar(nome),
        posts: grupos[nome].sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0))
      }));
    },
    abrirCategoriaPorQuery() {
      const queryBlog = this.normalizar(this.$route.query.blog || "");
      if (!queryBlog) {
        return;
      }

      const index = this.categorias.findIndex((item) => item.slug === queryBlog || item.slug.includes(queryBlog));
      if (index >= 0) {
        this.painel = index;
      }
    },
    resolveImagem(url) {
      if (!url) {
        return "";
      }
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return this.normalizarUrlDuplicada(url);
      }

      if (url.startsWith("/api/")) {
        return this.obterBaseApi() + this.normalizarUrlDuplicada(url);
      }

      return this.normalizarUrlDuplicada(url);
    },
    formatarData(data) {
      if (!data) return "";
      const valor = new Date(data);
      if (Number.isNaN(valor.getTime())) {
        return "";
      }
      return valor.toLocaleDateString("pt-BR");
    },
    prepararConteudo(conteudo) {
      let html = String(conteudo || "");

      // Converte v-img com fechamento completo para img.
      html = html.replace(/<v-img\b([^>]*)>[\s\S]*?<\/v-img>/gi, (_match, attrs) => {
        return this.converterTagVImgParaImg(attrs);
      });

      // Converte v-img simples/self-closing ou malformada para img.
      html = html.replace(/<v-img\b([^>]*?)\/?\s*>/gi, (_match, attrs) => {
        return this.converterTagVImgParaImg(attrs);
      });

      // Resolve src relativo de <img> para a URL base da API.
      html = html.replace(/(<img\b[^>]*\ssrc=['"])(\/api\/[^'"]+)(['"])/gi, (_match, antes, caminho, depois) => {
        return antes + this.resolveImagem(caminho) + depois;
      });

      // Marca tabelas/células para responsividade e remove largura fixa de imagens.
      html = html.replace(/<table\b(.*?)>/gi, (_match, attrs) => this.addClassToTag("table", attrs, "blog-conteudo-table"));
      html = html.replace(/<td\b(.*?)>/gi, (_match, attrs) => this.addClassToTag("td", attrs, "blog-conteudo-td"));
      html = html.replace(/<img\b([^>]*?)>/gi, (_match, attrs) => this.normalizarTagImg(attrs));

      return html;
    },
    addClassToTag(tagName, attrsRaw, className) {
      const attrs = String(attrsRaw || "");
      const classMatch = attrs.match(/\bclass=(['"])(.*?)\1/i);

      if (!classMatch) {
        return `<${tagName} class="${className}"${attrs}>`;
      }

      const classes = classMatch[2].split(/\s+/).filter((c) => !!c);

      if (!classes.includes(className)) {
        classes.push(className);
      }

      const attrsSemClass = attrs.replace(/\s*\bclass=(['"])(.*?)\1/i, "");
      return `<${tagName} class="${classes.join(" ")}"${attrsSemClass}>`;
    },
    normalizarTagImg(attrsRaw) {
      let attrs = String(attrsRaw || "")
        .replace(/\swidth=(['"]).*?\1/gi, "")
        .replace(/\sheight=(['"]).*?\1/gi, "");

      const srcMatch = attrs.match(/\bsrc=(['"])(.*?)\1/i);
      const src = srcMatch ? srcMatch[2] : "";
      if (!src) {
        return `<img${attrs}>`;
      }

      const styleMatch = attrs.match(/\bstyle=(['"])(.*?)\1/i);
      if (!styleMatch) {
        attrs += ` style="max-width:100%;height:auto;"`;
      } else if (!/max-width\s*:/i.test(styleMatch[2])) {
        const styleNovo = `${styleMatch[2].trim().replace(/;?$/, ";")}max-width:100%;height:auto;`;
        attrs = attrs.replace(/\bstyle=(['"])(.*?)\1/i, `style="${styleNovo}"`);
      }

      return `<img${attrs}>`;
    },
    converterTagVImgParaImg(attrsRaw) {
      const attrs = String(attrsRaw || "");
      const srcMatch = attrs.match(/src=(['"])(.*?)\1/i);
      const altMatch = attrs.match(/alt=(['"])(.*?)\1/i);
      const classMatch = attrs.match(/class=(['"])(.*?)\1/i);
      const styleMatch = attrs.match(/style=(['"])(.*?)\1/i);

      let src = srcMatch ? srcMatch[2] : "";
      const alt = altMatch ? altMatch[2] : "Imagem";
      const classes = classMatch ? classMatch[2] : "img-responsive";
      const style = styleMatch ? ` style="${styleMatch[2]}"` : "";

      if (!src) return "";
      src = this.normalizarUrlDuplicada(src);
      if (src.startsWith("/api/")) src = this.resolveImagem(src);

      return `<img class="${classes}" src="${src}" alt="${alt}" loading="lazy"${style} />`;
    },
    async carregarPosts() {
      this.carregando = true;
      try {
        const response = await api.get(process.env.VUE_APP_URL_API + "conteudo/blog?tamanho=200");
        const posts = response.data?.data || response.data || [];
        this.categorias = this.agruparPorCategoria(posts);
        this.abrirCategoriaPorQuery();
        this.selecionarPostPorLink();
      } catch {
        this.categorias = [];
        this.aplicarSeoPadrao();
      } finally {
        this.carregando = false;
      }
    }
  },
  created() {
    this.carregarPosts();
  },
  watch: {
    "$route.query.post"() {
      this.selecionarPostPorLink();
    },
    "$route.hash"() {
      this.selecionarPostPorLink();
    },
    "$route.query.blog"() {
      this.abrirCategoriaPorQuery();
      this.selecionarPostPorLink();
    }
  }
};
</script>

<style>
.blog-post-layout {
  align-items: flex-start;
}

.blog-post-capa {
  padding-left: 16px;
}

.blog-conteudo table {
  width: 100%;
  border-collapse: collapse;
}

.blog-conteudo .blog-conteudo-table {
  table-layout: fixed;
}

.blog-conteudo img {
  max-width: 100%;
  height: auto;
}

@media (max-width: 600px) {
  .blog-post-capa {
    padding-left: 0;
    margin-top: 12px;
  }

  .blog-conteudo table,
  .blog-conteudo .blog-conteudo-table,
  .blog-conteudo tbody,
  .blog-conteudo tr,
  .blog-conteudo td,
  .blog-conteudo .blog-conteudo-td {
    display: block;
    width: 100% !important;
  }

  .blog-conteudo td,
  .blog-conteudo .blog-conteudo-td {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
</style>
